import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Episodes from "@/pages/episodes/page";
import Characters from "@/pages/characters/page";
import EpisodeDetail from "@/pages/episode-detail/page";
import CharacterDetail from "@/pages/character-detail/page";
import Guide from "@/pages/guide/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "episodes", element: <Episodes /> },
      { path: "characters", element: <Characters /> },
      { path: "episode/:id", element: <EpisodeDetail /> },
      { path: "character/:id", element: <CharacterDetail /> },
      { path: "guide", element: <Guide /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;